<template>
  <div
    v-if="this.$store.state.app.loadingCount > 0 && $store.getters.currentTheme"
    id="loading-overlay"
    class="period"
  >
    <div class="loading">
      <img
        class="c01"
        :src="require(`@/assets/${$store.getters.currentTheme}/images/LogoLoading_circle01.png`)"
        alt=""
      >
      <img
        class="c02"
        :src="require(`@/assets/${$store.getters.currentTheme}/images/LogoLoading_circle02.png`)"
        alt=""
      >
      <img
        class="shinelight"
        :src="require(`@/assets/${$store.getters.currentTheme}/images/logo-2.webp`)"
        alt=""
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style scoped>

.loading {
	width: 180px;
	height: 180px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.period .loading img {
	position: absolute;
}

.c01 {
	animation: spin 3.333s linear infinite;
}

.c02 {
	animation: spin2 2.666s linear infinite;
}

.shinelight {
	max-width: 180px;
	height: auto;
}

@keyframes spin {
	0% {
		opacity: 1;
		transform: rotate(0deg);
	}
	50% {
		opacity: 0;
		transform: rotate(180deg);
	}
	100% {
		opacity: 1;
		transform: rotate(360deg);
	}
}

@keyframes spin2 {
	0% {
		opacity: 0;
		transform: rotate(0deg);
	}
	50% {
		opacity: 1;
		transform: rotate(-180deg);
	}
	100% {
		opacity: 0;
		transform: rotate(-360deg);
	}
}

@keyframes slide {
	0% {
		transform: translateX(-100%);
	}
	100% {
		transform: translateX(100%);
	}
}

#loading-overlay {
  position: fixed;
  background-color: rgba(225, 225, 225, .9);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1030;
  overflow-y: hidden;
}
</style>
